import PropTypes from 'prop-types';
import cn from 'classnames';

import Tooltip from 'components/common/Tooltip';
import { MoreInfo } from 'components/icons';
import css from 'styles/components/search/inlineBannerAd.scss';

const InlineBannerAd = ({ layoutStyle }, { marketplace: { shortName, hasBannerAds } }) => {
  if (!hasBannerAds) {
    return null;
  }
  return (
    <div className={cn(css.inlineAd, layoutStyle)}>
      {/* Just a placeholder container until Symphony wiring, where we'll use LandingPageLink */}
      <div className={css.innerWrapper}>
        <img alt="derp" src="https://github01.zappos.net/storage/user/668/files/1548cf80-d938-11e9-9219-a07eae17fd86" />
        <Tooltip
          content={`These are ads for products you'll find on ${shortName}.com. Clicking an ad will take you to the product's page.`}
          wrapperClassName={css.tooltipWrapper}
          tooltipClassName={css.tooltip}
          contentClassName={css.content}
          direction="down"
          tooltipId="inlineBannerAd"
        >
        Sponsored <MoreInfo />
        </Tooltip>
      </div>
    </div>
  );
};

InlineBannerAd.propTypes = {
  layoutStyle: PropTypes.string.isRequired
};

InlineBannerAd.contextTypes = {
  marketplace: PropTypes.object
};

export default InlineBannerAd;
